import { useTranslation } from "next-i18next";
import TrackIcon from "@/components/icons/TrackIcon";
import PaySecurelyIcon from "@/components/icons/PaySecurelyIcon";
import FastDeliveryIcon from "@/components/icons/FastDeliveryIcon";

const HomeBottomForMobileView = () => {
  const { t } = useTranslation("home");

  return (
    <div className="grid grid-cols-3 p-4 gap-x-2 md:hidden">
      <div className="flex flex-col items-center justify-center gap-2">
        <TrackIcon className="size-5" />
        <span className="text-[#784790] font-bold text-xs">
          {t("Track Order")}
        </span>
      </div>
      <div className="flex flex-col items-center justify-center gap-2">
        <PaySecurelyIcon className="size-5 text-[#784790]" />
        <span className="text-[#784790] font-bold text-xs">
          {t("Pay Securely")}
        </span>
      </div>
      <div className="flex flex-col items-center justify-center gap-2">
        <FastDeliveryIcon className="size-5 text-[#784790]" />
        <span className="text-[#784790] font-bold text-xs">
          {t("Fast Delivery")}
        </span>
      </div>
    </div>
  );
};

export default HomeBottomForMobileView;
